angular.module('app.admin').factory('sysOrgFleetSvc', [
    'amtXlatSvc',
    function (amtXlatSvc) {
        var svc = this;

        // Required function to generate active state objects
        svc.getActiveStates = function () {
            return [
                {
                    key: true,
                    description: amtXlatSvc.xlat('client.activeTrue'),
                    default: true
                },
                {
                    key: false,
                    description: amtXlatSvc.xlat('client.activeFalse'),
                    default: false
                }
            ];
        };

        // Assign to svc for external access
        svc.activeStates = svc.getActiveStates();

        return svc;
    }
]);